import { useQuery } from '@tanstack/react-query';
import { designModelApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const REFERENCE_STALE_TIME = 5 * 60_000;

/** @registry WBS labor accounts a design model can be attributed to. */
export function useDesignModelLaborAccounts(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.designModels.laborAccounts(jobId ?? -1),
    queryFn: ({ signal }) =>
      designModelApiClient.getLaborAccounts(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    staleTime: REFERENCE_STALE_TIME,
    meta: { errorContext: 'design model labor accounts' },
  });
}
